import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import SVG from "react-inlinesvg";
//import Link from "next/link";
// import dayjs from "dayjs";
import textLanguage from "@/constants/textLanguage";
import defaultAuthor from "@/constants/defaultAuthor";
import siteInfo from "@/constants/siteInfo";
import { convertDateTime } from "@/utils/dateTimeFormat";
import sendGAEvent from "@/utils/gaEvent";
import { useRouter } from "next/router";
// import { useRouter } from "next/router";

let placeholders = [
  {
    title: "loading...",
  },
  {
    title: "loading...",
  },
  {
    title: "loading...",
  },
  {
    title: "loading...",
  },
  {
    title: "loading...",
  },
  {
    title: "loading...",
  },
];

const Card = ({
  content,
  isMadhya = false,
  isRajasthan = false,
  isHR = false,
  isUP = false,
  isBH = false,
  isCGH = false,
  isUK = false,
}) => {
  // const router = useRouter();
  return (
    <div
      className="flex flex-col overflow-hidden"
      onClick={() => {
        // console.log("clicked", content?.canonical_url);
        let currentPageType = window?.location?.href?.includes("/video/");
        sendGAEvent({
          eventName: currentPageType
            ? "VideoPage-NewsClickFromYebhipade"
            : "ArticlePage-NewsClickFromYebhipade",
          pageTitle: content?.title,
          pageLocation: `${process.env.NEXT_PUBLIC_WEBSITE_URL}${content?.canonical_url}`,
        });
        window.location.href = `${process.env.NEXT_PUBLIC_WEBSITE_URL}${content?.canonical_url}`;
      }}
    >
      <div className="flex-shrink-0" style={{ zIndex: -1 }}>
        <div className="relative">
          <a href={content?.canonical_url}>
            <img
              className=" w-full object-cover rounded-md"
              src={`${content?.image_small}?size=320:180`}
              title={content?.title}
              alt={
                content?.title_short ? content?.title_short : siteInfo?.siteName
              }
              loading="lazy"
              role="button"
              width={320}
              height={180}
            //onClick={()=> router.push(content?.canonical_url)}
            />
            {content.photo_count > 0 && (
              <div className="absolute bottom-3 left-2 flex items-center gap-x-2 w-[4rem] rounded bg-black bg-opacity-60 text-white p-2">
                <SVG
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/gallery.svg"
                  className="mb-1 w-4 h-4"
                />
                <p>{content.photo_count}</p>
              </div>
            )}
          </a>
          {/* Conditionally render the play icon if the content type is video */}
          {content?.content_type === "video" && (
            <a href={content?.canonical_url}>
              <div
                role="button"
                className="absolute inset-0 flex justify-center items-center"
              >
                <img
                  className="w-10 h-10"
                  src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/play-media.svg"
                  alt="play"
                  loading="lazy"
                />
              </div>
            </a>
          )}
        </div>
      </div>

      <div className="py-2">
        <a href={content?.canonical_url}>
          <h3
            className={`text-md font-semibold line-clamp-3 text-gray-700 ${isMadhya
              ? "hover:text-mpDark"
              : isRajasthan
                ? "hover:text-rajasthanDark"
                : isHR
                  ? "hover:text-hrDark"
                  : isBH
                    ? "hover:text-biharDark"
                    : isUP
                      ? "hover:text-upDark"
                      : isCGH
                        ? "hover:text-mpDark"
                        : isUK
                          ? "hover:text-ukDark"
                          : "hover:text-primary"
              }`}
            dangerouslySetInnerHTML={{
              __html: `${content?.title || content?.title_short}`,
            }}
          />
        </a>
        <p className="text-xs text-gray-500 font-extralight mt-1 flex">
          <img
            className="h-3 w-3 inline-block mr-1"
            alt="read video icon"
            loading="lazy"
            src={
              content?.content_type === "video"
                ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/watchType.svg"
                : "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/readType.svg"
            }
          />
          <time dateTime={content?.datetime_published}>
            {/* {console.log("first", content?.datetime_published)} */}
            {convertDateTime(content?.datetime_published)}
          </time>{" "}
          {content?.author && (
            <a
              href={
                content?.author[0]?.canonical_url ?? defaultAuthor.canonical_url
              }
            >
              · By{" "}
              <span className={isMadhya ? "text-mpDark " : "text-primary"}>
                {content?.author[0]?.title ?? defaultAuthor.title}
              </span>
            </a>
          )}
        </p>
      </div>
    </div>
  );
};

const RelatedNews = ({ relatedNewsData = [], customTitle = "" }) => {
  const responsive = {
    // superLargeDesktop: {
    //   breakpoint: { max: 4000, min: 3001 },
    //   items: 4.2,
    //   slidesToSlide: 4,
    // },
    // largeDesktop: {
    //   breakpoint: { max: 3000, min: 2001 },
    //   items: 4.2,
    //   slidesToSlide: 4,
    // },
    desktop: {
      breakpoint: { max: 2000, min: 1551 },
      items: 3,
      slidesToSlide: 2,
    },
    laptop: {
      breakpoint: { max: 1550, min: 1201 },
      items: 3,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 1200, min: 992 },
      items: 2.5,
      slidesToSlide: 2,
    },
    mobile: {
      breakpoint: { max: 991, min: 500 },
      items: 2,
      slidesToSlide: 1,
    },
    smallMobile: {
      breakpoint: { max: 500, min: 426 },
      items: 1.5,
      slidesToSlide: 1,
    },
    verySmallMobile: {
      breakpoint: { max: 425, min: 380 },
      items: 1.2,
      slidesToSlide: 1,
    },
    extremelySmallMobile: {
      breakpoint: { max: 379, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  const isPhotoGallery = relatedNewsData[0].content_type == "photo_gallery";
  const router = useRouter();
  const isRajasthan = router?.asPath?.includes("/rajasthan");
  const isMadhya = router?.asPath?.includes("/madhya-pradesh");
  const isHR = router?.asPath?.includes("/haryana");
  const isBH = router?.asPath?.includes("/bihar");
  const isUP = router?.asPath?.includes("/uttar-pradesh");
  const isCGH = router?.asPath?.includes("/chhattisgarh");
  const isUK = router?.asPath?.includes("/uttarakhand");

  const CustomLeftArrow = ({ onClick, ...rest }) => {
    return (
      <button
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white text-primary rounded-full p-2 shadow-xl"
        {...rest}
      >
        <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/chevron-left.svg" className="w-4 h-4" />
      </button>
    );
  };

  const CustomRightArrow = ({ onClick, ...rest }) => {
    return (
      <button
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white text-primary rounded-full p-2 shadow-xl "
        {...rest}
      >
        <SVG
          src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/chevron-right.svg"
          className="w-4 h-4 stroke-2"
        />
      </button>
    );
  };

  // console.log("relatedNewsData", isRajasthan);
  return (
    <div className="my-2 min-h-[18rem] xs:min-h-[14rem] sm:min-h-[16rem]">
      <div className="flex">
        {isPhotoGallery && (
          <div className="font-bold text-xl">
            <h2
              className={`${isRajasthan
                ? "text-rajasthanDark"
                : isMadhya
                  ? "text-mpDark"
                  : isHR
                    ? "text-hrDark"
                    : isBH
                      ? "text-biharDark"
                      : isUP
                        ? "text-upDark"
                        : isCGH
                          ? "text-mpDark"
                          : isUK
                            ? "text-ukDark"
                            : "text-primary"
                } flex items-center gap-x-2`}
            >
              <SVG
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/gallery.svg"
                className="mb-1 w-4 h-4"
              />
              {customTitle ? customTitle : textLanguage?.relatedNewsText}
            </h2>
          </div>
        )}
        {!isPhotoGallery && (
          <div className="font-bold text-lg">
            <h2
              className="flex items-center gap-x-2"
              style={{
                color: isMadhya
                  ? "#0C8A70"
                  : isRajasthan
                    ? "#FED029"
                    : isHR
                      ? "#64BC46"
                      : isBH
                        ? "#CF4C9B"
                        : isUP
                          ? "#f6523e"
                          : isCGH
                            ? "#0C8A70"
                            : isUK
                              ? "#05a1fa"
                              : "",
              }}
            // className={`${
            //   isRajasthan
            //     ? "text-[#FED029]"
            //     : isMadhya
            //     ? "text-mpDark"
            //     : "text-primary"
            // }`}
            >
              <SVG src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/video.svg" className="mb-1 w-4 h-4" />
              {relatedNewsData &&
                relatedNewsData.length > 0 &&
                relatedNewsData[0].content_type === "video"
                ? customTitle || textLanguage?.relatedVideosText
                : textLanguage?.relatedNewsText}
            </h2>
          </div>
        )}
        {/* <div className="text-slate-500 font-normal text-sm ml-auto">
          <a href="/">
            <span>
              आणखी पाहा
              <SVG
                className="w-4 h-4 inline ml-2"
                src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/rightArrowRound.svg"
              />
            </span>
          </a>
        </div> */}
      </div>

      <div className="my-2 -ml-2" id="mobile-carousel">
        {/* <Carousel
          swipeable={true}
          draggable={false}
          responsive={responsive}
          infinite={false}
          autoPlay={false}
          keyBoardControl={false}
          //   customTransition="all .1"
          transitionDuration={500}
          //   removeArrowOnDeviceType={["tablet", "mobile", "smallMobile"]}
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
        > */}
        <div style={{ display: "flex", overflowX: "scroll" }}>
          {relatedNewsData && relatedNewsData.length > 0
            ? relatedNewsData?.map((item, index) => (
              <div className="px-2" key={index} style={{ minWidth: "17rem" }}>
                <Card
                  content={item}
                  isMadhya={isMadhya}
                  isRajasthan={isRajasthan}
                  isHR={isHR}
                  isBH={isBH}
                  isUP={isUP}
                  isCGH={isCGH}
                  isUk={isUK}
                />
              </div>
            ))
            : placeholders?.map((_, index) => (
              <div className="px-2" key={index}>
                <div
                  className={`h-40 bg-gray-200 flex justify-center items-center text-center rounded-md`}
                >
                  <p className="text-gray-500 font-semibold text-sm">
                    Loading...
                  </p>
                </div>
              </div>
            ))}
        </div>
        {/* </Carousel> */}
      </div>
      <div className="my-2" id="desktop-carousel">
        <Carousel
          swipeable={true}
          draggable={false}
          responsive={responsive}
          infinite={false}
          autoPlay={false}
          keyBoardControl={false}
          //   customTransition="all .1"
          transitionDuration={500}
          //   removeArrowOnDeviceType={["tablet", "mobile", "smallMobile"]}
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
        >
          {relatedNewsData && relatedNewsData.length > 0
            ? relatedNewsData?.map((item, index) => (
              <div className="px-2" key={index}>
                <Card
                  content={item}
                  isMadhya={isMadhya}
                  isRajasthan={isRajasthan}
                  isHR={isHR}
                  isBH={isBH}
                  isUP={isUP}
                  isCGH={isCGH}
                  isUk={isUK}
                />
              </div>
            ))
            : placeholders?.map((_, index) => (
              <div className="px-2" key={index}>
                <div
                  className={`h-40 bg-gray-200 flex justify-center items-center text-center rounded-md`}
                >
                  <p className="text-gray-500 font-semibold text-sm">
                    Loading...
                  </p>
                </div>
              </div>
            ))}
        </Carousel>
      </div>
      <style>
        {`
          #mobile-carousel{
           display: none;
          }
          #desktop-carousel{
          display: block;
          }
          @media screen and (max-width: 680px){
            #mobile-carousel{
              display: block;
            }
            #desktop-carousel{
              display: none;
            }
          }
          `}
      </style>
    </div>
  );
};

export default RelatedNews;
